export const ProfileUserIcon = (props: any) => (
  <svg
    {...props}
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.2876 35.2876C35.2876 36.2159 34.535 36.9684 33.6067 36.9684C32.6784 36.9684 31.9259 36.2159 31.9259 35.2876V31.9259C31.9259 29.141 29.6683 26.8834 26.8834 26.8834H13.4366C10.6517 26.8834 8.39412 29.141 8.39412 31.9259V35.2876C8.39412 36.2159 7.64158 36.9684 6.71328 36.9684C5.78498 36.9684 5.03244 36.2159 5.03244 35.2876V31.9259C5.03244 27.2844 8.79513 23.5217 13.4366 23.5217H26.8834C31.5249 23.5217 35.2876 27.2844 35.2876 31.9259V35.2876ZM20.16 20.16C15.5185 20.16 11.7558 16.3973 11.7558 11.7558C11.7558 7.11431 15.5185 3.35162 20.16 3.35162C24.8015 3.35162 28.5642 7.11431 28.5642 11.7558C28.5642 16.3973 24.8015 20.16 20.16 20.16ZM20.16 16.7983C22.9449 16.7983 25.2025 14.5407 25.2025 11.7558C25.2025 8.97092 22.9449 6.7133 20.16 6.7133C17.3751 6.7133 15.1175 8.97092 15.1175 11.7558C15.1175 14.5407 17.3751 16.7983 20.16 16.7983Z"
      fill="currentColor"
    />
  </svg>
)
